export enum ReportType {
  Institution = 'Institution',
  Contact = 'Contact',
  ContactTemplate = 'ContactTemplate',
  InstitutionTemplate = 'InstitutionTemplate',
  BnyManagementReport = 'BnyManagementReport',
  CapitalInsight = 'CapitalInsight',
  HistoricalOwnership = 'HistoricalOwnership',
  Itinerary = 'Itinerary',
  ItineraryTemplate = 'ItineraryTemplate',
  PeerOwnershipReport = 'PeerOwnershipReport',
  OwnershipAnalyticsReport = 'OwnershipAnalyticsReport',
  None = 'None'
}

export enum ReportActionTitle {
  Create = 'create',
  Modify = 'modify'
}

export const NewReportTemplateTypes = ['InvestorTemplate', 'ContactTemplate', 'BnyManagementReportTemplate'];
